import { UPSPickUpType, Source } from '../../shared/enum/general-enum';
import { Injectable } from "@angular/core";

@Injectable()
export class CostEstimate {
  ShipToResidential: boolean;
  ShipTo: ShipTo;
  ShipFrom: ShipFrom;

  Height = '0';
  Width = '0';
  Length = '0';
  Weight = '';

  InsuredValue: string;

  IsSaturdayPickUp: boolean = false;
  IsSaturdayDelivery: boolean = false;
  IsDeliveryConfirmation: boolean = false;

  IsCOD = false;
  CodAmount: string = '0';
  IsSecuredCOD = false;

  IsRegularPickUp = false;
  IsDropoff = true;

  SelectedServiceCode? = '';
}

export class ShipTo {
  ContactId = 'NOID';
  CustomerId = '';
  UserId: string;
  ContactType = '11';
  CompanyName: string;
  FirstName: string;
  LastName: string;
  StreetAddress: string;
  ApartmentSuite: string;
  ProvinceRegion: string;
  City: string;
  State: string;
  Country = '0';
  Zip: string;
  TelephoneNo: string;
  FaxNo: string;
  Email: string;
  NickName: string;
  IsExpress = false;
  IsResidential = false;
  IsUserDefault = false;
  UPSPickUpType: UPSPickUpType = UPSPickUpType.Occasional;
  TotalContacts = '0';
}

export class ShipFrom {
  ContactId = 'NOID';
  CustomerId = '';
  UserId: string;
  ContactType = '3';
  CompanyName: string;
  FirstName: string;
  LastName: string;
  StreetAddress: string;
  ApartmentSuite: string;
  ProvinceRegion: string;
  City: string;
  State: string;
  Country: string;
  Zip: string;
  TelephoneNo: string;
  FaxNo: string;
  Email: string;
  NickName: string;
  IsExpress = false;
  IsResidential = false;
  IsUserDefault = false;
  UPSPickUpType: UPSPickUpType = UPSPickUpType.Occasional;
  TotalContacts = '0';
}

